import { SET_SEARCH_PARAMS } from './action-types'


export function setSearchParams (params) {
	return (dispatch) => {
		dispatch({ type: SET_SEARCH_PARAMS, payload: { ...params } })
	}
}
